module.exports = __webpack_public_path__ + "static/media/main idea.98d3dba4.mp3";